<template>
  <div>
    <div
      class="mb-3 text-h3 font-medium"
      :class="$store.state.mobile ? '' : 'mt-4'"
    >
      <template v-if="$store.getters.languageGetter === '1'">
        إدارة دفتر العناوين
      </template>
      <template v-else>
        Manage Address Book
      </template>
    </div>
    <v-divider />
    <v-row v-if="loading">
      <v-col cols="12">
        <v-skeleton-loader
          type="sentences"
        />
      </v-col>
      <v-col
        v-for="i in 4"
        :key="i"
        :cols="$store.state.mobile ? 12 : 6"
      >
        <v-card
          outlined
          class="pb-3"
        >
          <div class="d-flex align-center pe-4">
            <v-skeleton-loader
              width="500"
              type="card-heading"
            />
            <v-spacer />
            <v-skeleton-loader
              type="button"
            />
          </div>
          <div class="px-4">
            <v-skeleton-loader
              type="paragraph"
            />
          </div>
        </v-card>
      </v-col>
    </v-row>
    <template v-else>
      <div class="grey lighten-3 py-2 ps-4 pe-2 d-flex align-center text-h5 black--text">
        <template v-if="$store.getters.languageGetter === '1'">
          عنوان الشحن الخاص بك
        </template>
        <template v-else>
          Your Shipping Address
        </template>
        <v-btn
          v-if="addressList.data.length"
          text
          class="ms-auto font-medium black--text"
          @click="show = !show"
        >
          <v-icon
            size="24"
            left
            color="#f51414"
          >
            mdi-plus
          </v-icon>
          <template v-if="$store.getters.languageGetter === '1'">
            أضف عنوانا جديدا
          </template>
          <template v-else>
            Add a New Address
          </template>
        </v-btn>
      </div>
      <v-row align="stretch">
        <v-col
          v-for="(item, i) in addressListGetter"
          :key="item.id"
          :cols="$store.state.mobile ? 12 : 6"
        >
          <v-card
            outlined
            tile
            class="pa-4 fill-height"
          >
            <v-row no-gutters>
              <v-col class="pe-4">
                <div class="text-h5 font-medium">
                  {{ item.contacter }}
                  <v-chip
                    v-if="item.isDefault === '1'"
                    small
                    color="#ff9a00"
                    dark
                    class="ms-2"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      تقصير
                    </template>
                    <template v-else>
                      Default
                    </template>
                  </v-chip>
                </div>
                <div class="my-2">
                  {{ item.countryName }}
                </div>
                <div class="my-2">
                  {{ item.city }} {{ item.province }}  ({{ item.zipCode }})
                </div>
                <div class="my-2">
                  {{ item.address }}
                </div>
                <div class="my-2">
                  (+{{ item.callingCodes }}) {{ item.mobile }}
                </div>
              </v-col>
              <v-col cols="auto">
                <v-menu
                  :open-on-hover="!$store.state.mobile"
                  bottom
                  offset-y
                  transition="scroll-y-reverse-transition"
                >
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-btn
                      color="primary"
                      dark
                      small
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    >
                      <template v-if="$store.getters.languageGetter === '1'">
                        عرض العملية
                      </template>
                      <template v-else>
                        Action
                      </template>
                      <v-icon
                        size="14"
                        right
                        class="flip-reverse"
                        :class="value ? 'reverse' : ''"
                      >
                        mdi-menu-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="editAddress(item)">
                      <v-list-item-title>
                        <template v-if="$store.getters.languageGetter === '1'">
                          يحرر
                        </template>
                        <template v-else>
                          Edit
                        </template>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="deleteAddress(item.id)"
                    >
                      <v-list-item-title>
                        <template v-if="$store.getters.languageGetter === '1'">
                          حذف
                        </template>
                        <template v-else>
                          Delete
                        </template>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      :disabled="item.isDefault === '1'"
                      @click="setDefaultAddress(i)"
                    >
                      <v-list-item-title>
                        <template v-if="$store.getters.languageGetter === '1'">
                          تقصير
                        </template>
                        <template v-else>
                          Default
                        </template>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <div class="text-center my-4">
        <v-btn
          v-if="!addressList.data.length"
          text
          class="ms-auto font-medium black--text"
          @click="show = !show"
        >
          <v-icon
            size="24"
            left
            color="#f51414"
          >
            mdi-plus
          </v-icon>
          <template v-if="$store.getters.languageGetter === '1'">
            أضف عنوانا جديدا
          </template>
          <template v-else>
            Add a New Address
          </template>
        </v-btn>
      </div>
    </template>
    <v-dialog
      v-model="show"
      max-width="650"
    >
      <Address
        :id="id"
        :item="item"
        :header="true"
        @update:close="show = false;id = ''; item = {}"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Address from '@/components/Address.vue';

export default {
  name: 'UserAddressList',
  components: {
    Address,
  },
  data() {
    return {
      show: false,
      loading: false,
      item: {},
      id: '',
    };
  },
  computed: {
    ...mapState('center', ['addressList']),
    ...mapGetters('center', ['addressListGetter']),
    // addressListLocal() {
    //   return this.addressList.data.map((item) => {
    //     const addressPart = item.addressPart.split('/') || [];
    //     const [province, city, address] = addressPart;
    //     return {
    //       province,
    //       city,
    //       address,
    //       ...item,
    //     };
    //   });
    // },
  },
  created() {
    this.loading = true;
    this.getAddressListAsync({ buyerId: this.$store.state.user.sellerId }).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions('center', ['getAddressListAsync', 'deleteAddressAsync', 'editAddressAsync']),
    deleteAddress(id) {
      this.$store.commit('SET_MINI_LOADING');
      this.deleteAddressAsync({ id, buyerId: this.$store.state.user.sellerId, buyerUid: this.$store.state.user.id }).finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
    editAddress(item) {
      this.item = item;
      this.id = item.id;
      this.show = true;
    },
    setDefaultAddress(i) {
      const item = { ...this.addressList.data[i] };
      item.isDefault = '1';
      this.$store.commit('SET_MINI_LOADING');
      this.editAddressAsync(item).finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
